import { IExperiments } from './experimentation.service'
import { Site, SiteIds } from '../models/site.model'
import { USER_STATUS } from '../../singleton-services/auth/auth.interfaces'
import { StripeSubscriptionStatus } from '../subscriptions/subscriptions.common'

const ALL_EXPERIMENTS = {} as IExperiments

export const FEAT_LIVE_ADS_MAYDAY_ID = 'flo_13081_live_ads_mayday_mayday'
export const FEAT_LIVE_ADS_MAYDAY_CONTROL = '0'
export const FEAT_LIVE_ADS_MAYDAY_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_LIVE_ADS_MAYDAY_ID] = {
  id: FEAT_LIVE_ADS_MAYDAY_ID,
  name: 'FLO-13081: Live Ads Mayday',
  variations: [
    {
      variationId: FEAT_LIVE_ADS_MAYDAY_CONTROL,
      variationName: 'Control'
    },
    {
      variationId: FEAT_LIVE_ADS_MAYDAY_VARIATION,
      variationName: 'Variation: Turn Off Live Ads'
    }
  ]
}

export const ALL_EXPERIMENT_DEFINITIONS = ALL_EXPERIMENTS

/**
 * CXP-1521: New athlete profile collection pages.
 * Feature flag branched from Entity Hubs/Entity Collections
 * because first release was only teams and leagues collection pages
 * and did not include people pages.
 */
export const EXP_NEW_ATHLETE_PROFILES_ID = 'cxp_1521_new_athlete_profiles'
export const EXP_NEW_ATHLETE_PROFILES_VARIATION = '1'
export const EXP_NEW_ATHLETE_PROFILES_CONTROL = '0'
ALL_EXPERIMENTS[EXP_NEW_ATHLETE_PROFILES_ID] = {
  id: EXP_NEW_ATHLETE_PROFILES_ID,
  name: 'New Athlete Entity Collections',
  variations: [
    {
      variationId: EXP_NEW_ATHLETE_PROFILES_CONTROL,
      variationName: 'Control: Old Athlete Profiles'
    },
    {
      variationId: EXP_NEW_ATHLETE_PROFILES_VARIATION,
      variationName: 'Variation: New Athlete Entity Collections'
    }
  ]
}

/**
 * CXP-1521: New collection entity pages for /collections/id and collections/tag routes.
 * Feature flag branched from Entity Hubs/Entity Collections
 * because first release was only teams and leagues collection pages,
 * did not include collection id or collection tag pages.
 */
export const EXP_NEW_COLLECTION_ENTITY_HUBS_ID = 'cxp_1521_new_collection_entity_hubs'
export const EXP_NEW_COLLECTION_ENTITY_HUBS_VARIATION = '1'
export const EXP_NEW_COLLECTION_ENTITY_HUBS_CONTROL = '0'
ALL_EXPERIMENTS[EXP_NEW_COLLECTION_ENTITY_HUBS_ID] = {
  id: EXP_NEW_COLLECTION_ENTITY_HUBS_ID,
  name: 'New Collection Entity Hubs',
  variations: [
    {
      variationId: EXP_NEW_COLLECTION_ENTITY_HUBS_CONTROL,
      variationName: 'Control: Old Collection Pages'
    },
    {
      variationId: EXP_NEW_COLLECTION_ENTITY_HUBS_VARIATION,
      variationName: 'Variation: New Collection Entities'
    }
  ]
}

/**
 * CXP-1714: Homepage Create Free Account
 */
// TODO: Remove
export const EXP_HOMEPAGE_CREATE_FREE_ACCOUNT_ID = 'cx_1714_hp_create_free_account_lead_gen'
export const EXP_HOMEPAGE_CREATE_FREE_ACCOUNT_VARIATION = '1'
export const EXP_HOMEPAGE_CREATE_FREE_ACCOUNT_CONTROL = '0'
ALL_EXPERIMENTS[EXP_HOMEPAGE_CREATE_FREE_ACCOUNT_ID] = {
  id: EXP_HOMEPAGE_CREATE_FREE_ACCOUNT_ID,
  name: 'CXP-1714: Homepage Create Free Account',
  variations: [
    {
      variationId: EXP_HOMEPAGE_CREATE_FREE_ACCOUNT_CONTROL,
      variationName: 'Control: Hide Create Free Account on Homepage'
    },
    {
      variationId: EXP_HOMEPAGE_CREATE_FREE_ACCOUNT_VARIATION,
      variationName: 'Variation: Show Create Free Account on Homepage'
    }
  ],
  criteria: [
    {
      type: 'user',
      inclusive: true,
      data: [USER_STATUS.ANONYMOUS]
    },
    {
      type: 'vertical',
      inclusive: true,
      data: [
        SiteIds.FLOHOOPS,
        SiteIds.FLOFOOTBALL,
        SiteIds.FLOHOCKEY,
        SiteIds.FLOSOFTBALL,
        SiteIds.FLOGRAPPLING,
        SiteIds.FLOWRESTLING,
        SiteIds.FLORACING,
        SiteIds.FLORUGBY,
        SiteIds.FLOBASEBALL
      ]
    }
  ]
}

/**
 * CXP-2285: Next Gen Navigation V2
 */
export const EXP_NEXT_GEN_NAVIGATION_V2 = 'cxp_2285_next_gen_navigation_v2'
export const EXP_NEXT_GEN_NAVIGATION_V2_CONTROL = '0'
export const EXP_NEXT_GEN_NAVIGATION_V2_VARIATION = '1'
ALL_EXPERIMENTS[EXP_NEXT_GEN_NAVIGATION_V2] = {
  id: EXP_NEXT_GEN_NAVIGATION_V2,
  name: 'CXP-2285: Next Gen Navigation v2',
  variations: [
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_CONTROL,
      variationName: 'Control: Show v1 of next gen navigation'
    },
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_VARIATION,
      variationName: 'Variation: Show v2 of next gen navigation'
    }
  ]
}

/**
 * CXP-3168: Next Gen Navigation V2 (Wrestling)
 */
export const EXP_NEXT_GEN_NAVIGATION_V2_WRESTLING = 'cxp_3168_next_gen_navigation_wrestling_v2'
export const EXP_NEXT_GEN_NAVIGATION_V2_WRESTLING_CONTROL = '0'
export const EXP_NEXT_GEN_NAVIGATION_V2_WRESTLING_VARIATION = '1'
ALL_EXPERIMENTS[EXP_NEXT_GEN_NAVIGATION_V2_WRESTLING] = {
  id: EXP_NEXT_GEN_NAVIGATION_V2_WRESTLING,
  name: 'CXP-3168: Next Gen Navigation v2 (Wrestling)',
  variations: [
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_WRESTLING_CONTROL,
      variationName: 'Control: Show v1 of next gen navigation for wrestling'
    },
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_WRESTLING_VARIATION,
      variationName: 'Variation: Show v2 of next gen navigation for wrestling'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOWRESTLING]
    }
  ]
}

/**
 * CXP-3169: Next Gen Navigation V2 (Track)
 */
export const EXP_NEXT_GEN_NAVIGATION_V2_TRACK = 'cxp_3169_next_gen_navigation_v2_track'
export const EXP_NEXT_GEN_NAVIGATION_V2_TRACK_CONTROL = '0'
export const EXP_NEXT_GEN_NAVIGATION_V2_TRACK_VARIATION = '1'
ALL_EXPERIMENTS[EXP_NEXT_GEN_NAVIGATION_V2_TRACK] = {
  id: EXP_NEXT_GEN_NAVIGATION_V2_TRACK,
  name: 'CXP-3169: Next Gen Navigation v2 (Track)',
  variations: [
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_TRACK_CONTROL,
      variationName: 'Control: Show v1 of next gen navigation for track'
    },
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_TRACK_VARIATION,
      variationName: 'Variation: Show v2 of next gen navigation for track'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOTRACK]
    }
  ]
}

/**
 * CXP-3169: Next Gen Navigation V2 (Track)
 */
export const EXP_NEXT_GEN_NAVIGATION_V2_VARSITY = 'cxp_3838_next_gen_navigation_v2_varsity'
export const EXP_NEXT_GEN_NAVIGATION_V2_VARSITY_CONTROL = '0'
export const EXP_NEXT_GEN_NAVIGATION_V2_VARSITY_VARIATION = '1'
ALL_EXPERIMENTS[EXP_NEXT_GEN_NAVIGATION_V2_VARSITY] = {
  id: EXP_NEXT_GEN_NAVIGATION_V2_VARSITY,
  name: 'CXP-3838: Next Gen Navigation v2 (Varsity)',
  variations: [
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_VARSITY_CONTROL,
      variationName: 'Control: Show v1 of next gen navigation for varsity'
    },
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_VARSITY_VARIATION,
      variationName: 'Variation: Show v2 of next gen navigation for varsity'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.VARSITY]
    }
  ]
}

/**
 * CXP-4840: Next Gen Navigation V2 (FloLive)
 */
export const EXP_NEXT_GEN_NAVIGATION_V2_FLOLIVE = 'cxp_4840_next_gen_navigation_v2_flolive'
export const EXP_NEXT_GEN_NAVIGATION_V2_FLOLIVE_CONTROL = '0'
export const EXP_NEXT_GEN_NAVIGATION_V2_FLOLIVE_VARIATION = '1'
ALL_EXPERIMENTS[EXP_NEXT_GEN_NAVIGATION_V2_FLOLIVE] = {
  id: EXP_NEXT_GEN_NAVIGATION_V2_FLOLIVE,
  name: 'CXP-4840: Next Gen Navigation v2 (FloLive)',
  variations: [
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_FLOLIVE_CONTROL,
      variationName: 'Control: Show v1 of next gen navigation for FloLive'
    },
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_FLOLIVE_VARIATION,
      variationName: 'Variation: Show v2 of next gen navigation for FloLive'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOLIVE]
    }
  ]
}

/**
 * CXP-5324: Next Gen Navigation V2 (FloCollege)
 */
export const EXP_NEXT_GEN_NAVIGATION_V2_FLOCOLLEGE = 'cxp_5324_next_gen_navigation_v2_flocollege'
export const EXP_NEXT_GEN_NAVIGATION_V2_FLOCOLLEGE_CONTROL = '0'
export const EXP_NEXT_GEN_NAVIGATION_V2_FLOCOLLEGE_VARIATION = '1'
ALL_EXPERIMENTS[EXP_NEXT_GEN_NAVIGATION_V2_FLOCOLLEGE] = {
  id: EXP_NEXT_GEN_NAVIGATION_V2_FLOCOLLEGE,
  name: 'CXP-5324: Next Gen Navigation v2 (FloCollege)',
  variations: [
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_FLOCOLLEGE_CONTROL,
      variationName: 'Control: Show v1 of next gen navigation for FloCollege'
    },
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_FLOCOLLEGE_VARIATION,
      variationName: 'Variation: Show v2 of next gen navigation for FloCollege'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOCOLLEGE]
    }
  ]
}

/**
 * CXP-5324: Next Gen Navigation V2 (Flograppling)
 */
export const EXP_NEXT_GEN_NAVIGATION_V2_FLOGRAPPLING = 'cxp_5324_next_gen_navigation_v2_flograppling'
export const EXP_NEXT_GEN_NAVIGATION_V2_FLOGRAPPLING_CONTROL = '0'
export const EXP_NEXT_GEN_NAVIGATION_V2_FLOGRAPPLING_VARIATION = '1'
ALL_EXPERIMENTS[EXP_NEXT_GEN_NAVIGATION_V2_FLOGRAPPLING] = {
  id: EXP_NEXT_GEN_NAVIGATION_V2_FLOGRAPPLING,
  name: 'CXP-5324: Next Gen Navigation v2 (Flograppling)',
  variations: [
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_FLOGRAPPLING_CONTROL,
      variationName: 'Control: Show v1 of next gen navigation for Flograppling'
    },
    {
      variationId: EXP_NEXT_GEN_NAVIGATION_V2_FLOGRAPPLING_VARIATION,
      variationName: 'Variation: Show v2 of next gen navigation for Flograppling'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOGRAPPLING]
    }
  ]
}

/**
 * CXP-9347: Next Gen Event-hub
 */
export const EXP_NEXT_GEN_EVENT_HUB_WRESTLING = 'infra_5707_nextgen_wrestling'
export const EXP_NEXT_GEN_EVENT_HUB_WRESTLING_CONTROL = '0'
export const EXP_NEXT_GEN_EVENT_HUB_WRESTLING_VARIATION = '1'
ALL_EXPERIMENTS[EXP_NEXT_GEN_EVENT_HUB_WRESTLING] = {
  id: EXP_NEXT_GEN_EVENT_HUB_WRESTLING,
  name: 'CXP-9347: Next Gen Event-hub',
  variations: [
    {
      variationId: EXP_NEXT_GEN_EVENT_HUB_WRESTLING_CONTROL,
      variationName: 'Control: Show legacy event hub for Flowrestling'
    },
    {
      variationId: EXP_NEXT_GEN_EVENT_HUB_WRESTLING_VARIATION,
      variationName: 'Variation: Show next gen event hub for Flowrestling'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOWRESTLING]
    }
  ]
}

/**
 * CXP-9347: Next Gen Event-hub short link
 */

export const EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT = '9a8fde5b'
export const EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT_CONTROL = '0'
export const EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT_VARIATION = '1'
ALL_EXPERIMENTS[EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT] = {
  id: EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT,
  name: 'CXP-9347: Next Gen Event-hub short link',
  variations: [
    {
      variationId: EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT_CONTROL,
      variationName: 'Control: Show legacy event hub for Flowrestling'
    },
    {
      variationId: EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT_VARIATION,
      variationName: 'Variation: Show next gen event hub for Flowrestling'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOWRESTLING]
    }
  ]
}

/**
 * CXP-1958: Sub Promo Banner
 */
export const EXP_SUB_PROMO_BANNER = 'cxp_1958_sub_promo_banner'
export const EXP_SUB_PROMO_BANNER_CONTROL = '0'
export const EXP_SUB_PROMO_BANNER_VARIATION = '1'
ALL_EXPERIMENTS[EXP_SUB_PROMO_BANNER] = {
  id: EXP_SUB_PROMO_BANNER,
  name: 'CXP-1958: Sub Promo Banner',
  variations: [
    {
      variationId: EXP_SUB_PROMO_BANNER_CONTROL,
      variationName: 'Control: Hide sub promo banner on FloWrestling'
    },
    {
      variationId: EXP_SUB_PROMO_BANNER_VARIATION,
      variationName: 'Variation: Show sub promo banner on FloWrestling'
    }
  ],
  criteria: [
    {
      type: 'user',
      inclusive: true,
      data: [USER_STATUS.ANONYMOUS]
    },
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOWRESTLING]
    }
  ]
}

/**
 * CXP-2154: Expanded Sub Promo Banner
 */
export const EXP_EXPANDED_SUB_PROMO_BANNER = 'cxp_2154_expanded_sub_promo_banner'
export const EXP_EXPANDED_SUB_PROMO_BANNER_CONTROL = '0'
export const EXP_EXPANDED_SUB_PROMO_BANNER_VARIATION = '1'
ALL_EXPERIMENTS[EXP_EXPANDED_SUB_PROMO_BANNER] = {
  id: EXP_EXPANDED_SUB_PROMO_BANNER,
  name: 'CXP-2154: Expanded Sub Promo Banner',
  variations: [
    {
      variationId: EXP_EXPANDED_SUB_PROMO_BANNER_CONTROL,
      variationName: 'Control: Hide SPB for Racing, Grappling, Hockey, Track, Cheer, and Varsity'
    },
    {
      variationId: EXP_EXPANDED_SUB_PROMO_BANNER_VARIATION,
      variationName: 'Variation: Show SPB for Racing, Grappling, Hockey, Track, Cheer, and Varsity'
    }
  ],
  criteria: [
    {
      type: 'user',
      inclusive: true,
      data: [USER_STATUS.ANONYMOUS]
    },
    {
      type: 'vertical',
      inclusive: true,
      data: [
        SiteIds.FLORACING,
        SiteIds.FLOGRAPPLING,
        SiteIds.FLOHOCKEY,
        SiteIds.FLOTRACK,
        SiteIds.VARSITY,
        SiteIds.FLOCHEER
      ]
    }
  ]
}

/**
 * CXP-2491: Sub Promo Banner Test #3
 */
export const EXP_SUB_PROMO_BANNER_TEST_3 = 'cxp_2491_sub_promo_banner_test_3'
export const EXP_SUB_PROMO_BANNER_TEST_3_CONTROL = '0'
export const EXP_SUB_PROMO_BANNER_TEST_3_VARIATION = '1'
ALL_EXPERIMENTS[EXP_SUB_PROMO_BANNER_TEST_3] = {
  id: EXP_SUB_PROMO_BANNER_TEST_3,
  name: 'CXP-2491: Sub Promo Banner Test #3',
  variations: [
    {
      variationId: EXP_SUB_PROMO_BANNER_TEST_3_CONTROL,
      variationName: 'Control: Hide SPB for Marching, Baseball, Rugby, and Bikes'
    },
    {
      variationId: EXP_SUB_PROMO_BANNER_TEST_3_VARIATION,
      variationName: 'Variation: Show SPB for Marching, Baseball, Rugby, and Bikes'
    }
  ],
  criteria: [
    {
      type: 'user',
      inclusive: true,
      data: [USER_STATUS.ANONYMOUS]
    },
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOMARCHING, SiteIds.FLOBASEBALL, SiteIds.FLORUGBY, SiteIds.FLOBIKES]
    }
  ]
}

/**
 * CXP-2265: Live Like on FloCheer
 */
export const FEAT_SHOW_LIVE_LIKE_ON_CHEER_ID = 'cxp_2265_live_like_flo_cheer'
export const FEAT_SHOW_LIVE_LIKE_ON_CHEER_CONTROL = '0'
export const FEAT_SHOW_LIVE_LIKE_ON_CHEER_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_SHOW_LIVE_LIKE_ON_CHEER_ID] = {
  id: FEAT_SHOW_LIVE_LIKE_ON_CHEER_ID,
  name: 'CXP-2265: Live Like on FloCheer',
  variations: [
    {
      variationId: FEAT_SHOW_LIVE_LIKE_ON_CHEER_CONTROL,
      variationName: 'Control: Hide Live Like on FloCheer'
    },
    {
      variationId: FEAT_SHOW_LIVE_LIKE_ON_CHEER_VARIATION,
      variationName: 'Variation: Show Live Like on FloCheer'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOCHEER]
    }
  ]
}

/**
 * CXP-2618: Use New Pricing Architecture Feature Flag
 * Entitlements, Payments, Offers
 */
export const FEAT_PRICING_ARCH_ID = 'cxp_2618_feat_pricing_arch'
export const FEAT_PRICING_ARCH_VARIATION = '1'
export const FEAT_PRICING_ARCH_CONTROL = '0'
export const FEAT_PRICING_ARCH_VERTICALS = [
  SiteIds.FLOBASEBALL,
  SiteIds.FLOBIKES,
  SiteIds.FLOBOWLING,
  SiteIds.FLOCHEER,
  SiteIds.FLOCOLLEGE,
  SiteIds.FLOCOMBAT,
  SiteIds.FLODANCE,
  SiteIds.FLODOGS,
  SiteIds.FLOELITE,
  SiteIds.FLOFC,
  SiteIds.FLOFOOTBALL,
  SiteIds.FLOGRAPPLING,
  SiteIds.FLOGYMNASTICS,
  SiteIds.FLOHOCKEY,
  SiteIds.FLOHOOPS,
  SiteIds.FLOMARCHING,
  SiteIds.FLORACING,
  SiteIds.FLORODEO,
  SiteIds.FLORUGBY,
  SiteIds.FLOSOFTBALL,
  SiteIds.FLOSWIMMING,
  SiteIds.FLOTRACK,
  SiteIds.FLOVOLLEYBALL,
  SiteIds.FLOVOICE,
  SiteIds.VARSITY,
  SiteIds.FLOLIVE
]
ALL_EXPERIMENTS[FEAT_PRICING_ARCH_ID] = {
  id: FEAT_PRICING_ARCH_ID,
  name: 'CXP-2618: Use New Pricing Architecture Feature Flag',
  variations: [
    {
      variationId: FEAT_PRICING_ARCH_CONTROL,
      variationName: 'Control: Use existing pricing architecture'
    },
    {
      variationId: FEAT_PRICING_ARCH_VARIATION,
      variationName: 'Variation: Enable the new pricing architecture'
    }
  ],
  criteria: [
    {
      type: 'subscription',
      inclusive: false,
      data: [StripeSubscriptionStatus.CANCELLED, StripeSubscriptionStatus.ACTIVE]
    },
    {
      type: 'vertical',
      inclusive: true,
      data: FEAT_PRICING_ARCH_VERTICALS
    }
  ]
}

/**
 * CXP-9229: Account Pausing (New pricing architecture & monthly only)
 */
export const EXP_ACCOUNT_PAUSING_ID = 'cxp_9229_account_pausing'
export const EXP_ACCOUNT_PAUSING_CONTROL = '0'
export const EXP_ACCOUNT_PAUSING_VARIATION = '1'
ALL_EXPERIMENTS[EXP_ACCOUNT_PAUSING_ID] = {
  id: EXP_ACCOUNT_PAUSING_ID,
  name: 'CXP-9229: Account Pausing',
  variations: [
    {
      variationId: EXP_ACCOUNT_PAUSING_CONTROL,
      variationName: 'Control: Hide Account Pausing'
    },
    {
      variationId: EXP_ACCOUNT_PAUSING_VARIATION,
      variationName: 'Variation: Show Account Pausing'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: FEAT_PRICING_ARCH_VERTICALS
    }
  ]
}

/**
 * OFP-696: Site Settings Pass-Through
 */
export const FEAT_SITE_SETTINGS_PASS_THROUGH_ID = 'ofp_696_site_settings_pass_through'
export const FEAT_SITE_SETTINGS_PASS_THROUGH_CONTROL = '0'
export const FEAT_SITE_SETTINGS_PASS_THROUGH_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_SITE_SETTINGS_PASS_THROUGH_ID] = {
  id: FEAT_SITE_SETTINGS_PASS_THROUGH_ID,
  name: 'Use BFF pass through endpoint to retrieve site settings',
  variations: [
    {
      variationId: FEAT_SITE_SETTINGS_PASS_THROUGH_CONTROL,
      variationName: 'Control: Use Core API to retrieve site settings'
    },
    {
      variationId: FEAT_SITE_SETTINGS_PASS_THROUGH_VARIATION,
      variationName: 'Variation: Use BFF to retrieve site settings'
    }
  ]
}

/**
 * CXP-3347: FloHockey CAD Pricing
 */
export const EXP_HOCKEY_CAD_ID = 'cxp_3347_hockey_cad_v2'
export const EXP_HOCKEY_CAD_CONTROL = '0'
export const EXP_HOCKEY_CAD_VARIATION_1 = '1'
ALL_EXPERIMENTS[EXP_HOCKEY_CAD_ID] = {
  id: EXP_HOCKEY_CAD_ID,
  name: 'CXP-3347 V2: CAD pricing on FloHockey',
  variations: [
    {
      variationId: EXP_HOCKEY_CAD_CONTROL,
      variationName: 'Control: Show USD'
    },
    {
      variationId: EXP_HOCKEY_CAD_VARIATION_1,
      variationName: 'Variation 1: Show CAD'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOHOCKEY]
    }
  ]
}

/**
 * CXP-8152: FloRacing Price Increase Holdout
 */
export const EXP_RACING_PRICE_INCREASE_HOLDOUT_ID = 'cxp_8152_racing_price_increase_holdout'
export const EXP_RACING_PRICE_INCREASE_HOLDOUT_CONTROL = '0'
export const EXP_RACING_PRICE_INCREASE_HOLDOUT_VARIATION = '1'
ALL_EXPERIMENTS[EXP_RACING_PRICE_INCREASE_HOLDOUT_ID] = {
  id: EXP_RACING_PRICE_INCREASE_HOLDOUT_ID,
  name: 'CXP-8152: FloRacing Price Increase Holdout',
  variations: [
    {
      variationId: EXP_RACING_PRICE_INCREASE_HOLDOUT_CONTROL,
      variationName: 'Control: Show current pricing'
    },
    {
      variationId: EXP_RACING_PRICE_INCREASE_HOLDOUT_VARIATION,
      variationName: 'Variation: Show experiment pricing'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLORACING]
    }
  ]
}

/**
 * CXP-3402: FloWrestling Event Hub Brackets
 */
export const EXP_FLOWRESTLING_EVENT_HUB_BRACKETS_ID = 'cxp_3402_bracket_convergence_web'
export const EXP_FLOWRESTLING_EVENT_HUB_BRACKETS_CONTROL = '0'
export const EXP_FLOWRESTLING_EVENT_HUB_BRACKETS_VARIATION = '1'
ALL_EXPERIMENTS[EXP_FLOWRESTLING_EVENT_HUB_BRACKETS_ID] = {
  id: EXP_FLOWRESTLING_EVENT_HUB_BRACKETS_ID,
  name: 'CXP-3402: FloWrestling bracket convergence web',
  variations: [
    {
      variationId: EXP_FLOWRESTLING_EVENT_HUB_BRACKETS_CONTROL,
      variationName: 'Control: Hide Brackets tab on event hub'
    },
    {
      variationId: EXP_FLOWRESTLING_EVENT_HUB_BRACKETS_VARIATION,
      variationName: 'Variation: Show Brackets tab on event hub'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOWRESTLING]
    }
  ]
}

/**
 * OFP-1150: OFP Powers Article List Page
 */
export const FEAT_OFP_DATA_ARTICLE_LIST_ID = 'ofp_1150_ofp_powers_article_list_page'
export const FEAT_OFP_DATA_ARTICLE_LIST_CONTROL = '0'
export const FEAT_OFP_DATA_ARTICLE_LIST_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_OFP_DATA_ARTICLE_LIST_ID] = {
  id: FEAT_OFP_DATA_ARTICLE_LIST_ID,
  name: 'OFP-1150: OFP Powers Article List Page',
  variations: [
    {
      variationId: FEAT_OFP_DATA_ARTICLE_LIST_CONTROL,
      variationName: 'Control: Article list page data powered by Core API'
    },
    {
      variationId: FEAT_OFP_DATA_ARTICLE_LIST_VARIATION,
      variationName: 'Variation: Article list page data powered by OFP'
    }
  ]
}

/*
 * OFP-2775: Support OFP rollout to 100%
 */
export const FEAT_OFP_DATA_SEARCH_ID = 'ofp_2775_ofp_powers_search_100'

export const FEAT_OFP_DATA_SEARCH_CONTROL = '0'
export const FEAT_OFP_DATA_SEARCH_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_OFP_DATA_SEARCH_ID] = {
  id: FEAT_OFP_DATA_SEARCH_ID,
  name: 'OFP-2775: OFP Powers Search (100%)',
  variations: [
    {
      variationId: FEAT_OFP_DATA_SEARCH_CONTROL,
      variationName: 'Control: Search powered by Core API'
    },
    {
      variationId: FEAT_OFP_DATA_SEARCH_VARIATION,
      variationName: 'Variation: Search powered by OFP'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOWRESTLING]
    }
  ]
}

/**
 * Feature flag for event ticker
 */
export const FEAT_EVENT_TICKER_ID = 'feat_event_ticker'
export const FEAT_EVENT_TICKER_CONTROL = '0' // Do not show
export const FEAT_EVENT_TICKER_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_EVENT_TICKER_ID] = {
  id: FEAT_EVENT_TICKER_ID,
  name: 'Event Ticker',
  variations: [
    {
      variationId: FEAT_EVENT_TICKER_CONTROL,
      variationName: 'Control: Hide Event Ticker'
    },
    {
      variationId: FEAT_EVENT_TICKER_VARIATION,
      variationName: 'Variation: Show Event Ticker'
    }
  ]
}

/**
 * Feature flag Gifting
 *
 * @see {@link https://flocasts.atlassian.net/browse/CXP-3886}
 */
export const FEAT_GIFTING_ID = 'CXP-3886_feat_gifting'
export const FEAT_GIFTING_CONTROL = '0' // Do not show
export const FEAT_GIFTING_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_GIFTING_ID] = {
  id: FEAT_GIFTING_ID,
  name: 'CXP-3886 Gifting',
  variations: [
    {
      variationId: FEAT_GIFTING_CONTROL,
      variationName: 'Control: Hide Gifting'
    },
    {
      variationId: FEAT_GIFTING_VARIATION,
      variationName: 'Variation: Show Gifting'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: FEAT_PRICING_ARCH_VERTICALS
    }
  ]
}

/**
 * PE-1446: Display FloWrestling Brackets UI: https://flocasts.atlassian.net/browse/PE-1446
 */
export const EXP_FLOWRESTLING_BRACKETS_ID = 'pe_1446_display_flowrestling_brackets_ui'
export const EXP_FLOWRESTLING_BRACKETS_CONTROL = '0'
export const EXP_FLOWRESTLING_BRACKETS_VARIATION = '1'
ALL_EXPERIMENTS[EXP_FLOWRESTLING_BRACKETS_ID] = {
  id: EXP_FLOWRESTLING_BRACKETS_ID,
  name: 'PE-1446: Display FloWrestling Brackets UI',
  variations: [
    {
      variationId: EXP_FLOWRESTLING_BRACKETS_CONTROL,
      variationName: 'Control: Hide FloWrestling Brackets UI'
    },
    {
      variationId: EXP_FLOWRESTLING_BRACKETS_VARIATION,
      variationName: 'Variation: Display FloWrestling Brackets UI'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOWRESTLING]
    }
  ]
}

/**
 * CXP-6434: New Thank You Page Feature
 */
export const FEAT_NEW_THANK_YOU_PAGE_ID = 'cxp_6434_new_thank_you_page_feature'
export const FEAT_NEW_THANK_YOU_PAGE_CONTROL = '0'
export const FEAT_NEW_THANK_YOU_PAGE_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_NEW_THANK_YOU_PAGE_ID] = {
  id: FEAT_NEW_THANK_YOU_PAGE_ID,
  name: 'CXP-6434: New Thank You Page Feature',
  variations: [
    {
      variationId: FEAT_NEW_THANK_YOU_PAGE_CONTROL,
      variationName: 'Control: Old Thank You Page'
    },
    {
      variationId: FEAT_NEW_THANK_YOU_PAGE_VARIATION,
      variationName: 'Variation: New Thank You Page'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [
        SiteIds.FLORACING,
        SiteIds.FLOWRESTLING,
        SiteIds.FLOHOCKEY,
        SiteIds.FLOFOOTBALL,
        SiteIds.FLOGRAPPLING,
        SiteIds.FLOCOLLEGE
      ]
    }
  ]
}

/**
 * CXP-6433: New Funnel Landing Page Feature
 */
export const FEAT_NEW_FUNNEL_LANDING_PAGE_ID = 'cxp_6433_new_funnel_landing_page_feature'
export const FEAT_NEW_FUNNEL_LANDING_PAGE_CONTROL = '0'
export const FEAT_NEW_FUNNEL_LANDING_PAGE_VARIATION_1 = '1'
export const FEAT_NEW_FUNNEL_LANDING_PAGE_VARIATION_2 = '2'
ALL_EXPERIMENTS[FEAT_NEW_FUNNEL_LANDING_PAGE_ID] = {
  id: FEAT_NEW_FUNNEL_LANDING_PAGE_ID,
  name: 'CXP-6433: New Funnel Landing Page Feature',
  variations: [
    {
      variationId: FEAT_NEW_FUNNEL_LANDING_PAGE_CONTROL,
      variationName: 'Control: Old Funnel Landing Page'
    },
    {
      variationId: FEAT_NEW_FUNNEL_LANDING_PAGE_VARIATION_1,
      variationName: 'Variation: New Funnel Landing Page w/ no plans displayed'
    },
    {
      variationId: FEAT_NEW_FUNNEL_LANDING_PAGE_VARIATION_2,
      variationName: 'Variation: New Funnel Landing Page w/ plans displayed'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [
        SiteIds.FLOHOCKEY,
        SiteIds.FLOWRESTLING,
        SiteIds.VARSITY,
        SiteIds.FLODOGS,
        SiteIds.FLOTRACK,
        SiteIds.FLOGRAPPLING,
        SiteIds.FLOCOLLEGE,
        SiteIds.FLORACING,
        SiteIds.FLOSOFTBALL,
        SiteIds.FLOCHEER,
        SiteIds.FLOMARCHING,
        SiteIds.FLORUGBY,
        SiteIds.FLOBIKES,
        SiteIds.FLOBASEBALL
      ]
    }
  ]
}

/**
 * CXP-7255: New Single-Click Mobile Plans Page Feature
 */
export const FEAT_SINGLE_CLICK_MOBILE_PLANS_ID = 'cxp_7255_single_click_mobile_plans_feature'
export const FEAT_SINGLE_CLICK_MOBILE_PLANS_CONTROL = '0'
export const FEAT_SINGLE_CLICK_MOBILE_PLANS_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_SINGLE_CLICK_MOBILE_PLANS_ID] = {
  id: FEAT_SINGLE_CLICK_MOBILE_PLANS_ID,
  name: 'CXP-7255: New Single-Click Mobile Plans Page Feature',
  variations: [
    {
      variationId: FEAT_SINGLE_CLICK_MOBILE_PLANS_CONTROL,
      variationName: 'Control: Old Mobile Plans Page'
    },
    {
      variationId: FEAT_SINGLE_CLICK_MOBILE_PLANS_VARIATION,
      variationName: 'Variation: New Single-Click Mobile Plans Page'
    }
  ],
  criteria: [
    {
      type: 'platform',
      inclusive: true,
      data: ['mobile']
    },
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOCOLLEGE]
    }
  ]
}

/**
 * CXP-8819: New Single-Click Desktop Plans Page Feature
 */
export const FEAT_SINGLE_CLICK_DESKTOP_PLANS_ID = 'cxp_8819_single_click_desktop_plans_feature'
export const FEAT_SINGLE_CLICK_DESKTOP_PLANS_CONTROL = '0'
export const FEAT_SINGLE_CLICK_DESKTOP_PLANS_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_SINGLE_CLICK_DESKTOP_PLANS_ID] = {
  id: FEAT_SINGLE_CLICK_DESKTOP_PLANS_ID,
  name: 'CXP-8819: New Single-Click Desktop Plans Page Feature',
  variations: [
    {
      variationId: FEAT_SINGLE_CLICK_DESKTOP_PLANS_CONTROL,
      variationName: 'Control: Old Desktop Plans Page'
    },
    {
      variationId: FEAT_SINGLE_CLICK_DESKTOP_PLANS_VARIATION,
      variationName: 'Variation: New Single-Click Desktop Plans Page'
    }
  ],
  criteria: [
    {
      type: 'platform',
      inclusive: true,
      data: ['desktop']
    },
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOCOLLEGE]
    }
  ]
}

export const EXP_CHOOSE_FAVORITES_ID = 'cxp_7284_choose_favorites'
export const EXP_CHOOSE_FAVORITES_CONTROL = '0'
export const EXP_CHOOSE_FAVORITES_VARIATION = '1'
ALL_EXPERIMENTS[EXP_CHOOSE_FAVORITES_ID] = {
  id: EXP_CHOOSE_FAVORITES_ID,
  name: 'CXP-7284: Choose Favorites',
  variations: [
    {
      variationId: EXP_CHOOSE_FAVORITES_CONTROL,
      variationName: 'Control: Hide Choose Favorites'
    },
    {
      variationId: EXP_CHOOSE_FAVORITES_VARIATION,
      variationName: 'Variation: Show Choose Favorites'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOCOLLEGE]
    }
  ]
}

export const FEAT_BFF_SEARCH_PAGE_ID = 'cxp_7170_bff_search_page'
export const FEAT_BFF_SEARCH_PAGE_CONTROL = '0'
export const FEAT_BFF_SEARCH_PAGE_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_BFF_SEARCH_PAGE_ID] = {
  id: FEAT_BFF_SEARCH_PAGE_ID,
  name: 'CXP-7170: Display BFF-driven search page',
  variations: [
    {
      variationId: FEAT_BFF_SEARCH_PAGE_CONTROL,
      variationName: 'Control: Hide BFF-driven search page'
    },
    {
      variationId: FEAT_BFF_SEARCH_PAGE_VARIATION,
      variationName: 'Variation: Display BFF-driven search page'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      // Any additional verticals allow support for a BFF-driven search page can be added here.
      // Currently the BFF-rendering does not support OFP search, so must be limited to
      // verticals that are not on OFP for the time being.
      data: [SiteIds.FLOCOLLEGE]
    }
  ]
}

/**
 * CXP-7561: FloCollege in flyout
 * Add FloCollege to the flyout navigation
 */
export const EXP_FLOCOLLEGE_FLYOUT_ID = 'cxp_7561_flocollege_in_flyout'
export const EXP_FLOCOLLEGE_FLYOUT_CONTROL = '0'
export const EXP_FLOCOLLEGE_FLYOUT_VARIATION = '1'
ALL_EXPERIMENTS[EXP_FLOCOLLEGE_FLYOUT_ID] = {
  id: EXP_FLOCOLLEGE_FLYOUT_ID,
  name: 'CXP-7561: FloCollege in flyout',
  variations: [
    {
      variationId: EXP_FLOCOLLEGE_FLYOUT_CONTROL,
      variationName: 'Control: Hidden from flyout'
    },
    {
      variationId: EXP_FLOCOLLEGE_FLYOUT_VARIATION,
      variationName: 'Variation: Shown in flyout'
    }
  ]
}

/**
 * CXP-8207: Varsity Promo Bag
 */
export const FEAT_VARSITY_PROMO_BAG_ID = 'cxp_8207_varsity_promo_bag'
export const FEAT_VARSITY_PROMO_BAG_CONTROL = '0'
export const FEAT_VARSITY_PROMO_BAG_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_VARSITY_PROMO_BAG_ID] = {
  id: FEAT_VARSITY_PROMO_BAG_ID,
  name: 'CXP-8207: Varsity Promo Bag',
  variations: [
    {
      variationId: FEAT_VARSITY_PROMO_BAG_CONTROL,
      variationName: 'Control: Hide promotional bag'
    },
    {
      variationId: FEAT_VARSITY_PROMO_BAG_VARIATION,
      variationName: 'Variation: Show promotional bag'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.VARSITY]
    }
  ]
}

/**
 * CXP-8306: Enable New Stripe Tax - No longer using Avalara
 */
export const FEAT_STRIPE_TAX_ID = 'cxp_8306_stripe_tax'
export const FEAT_STRIPE_TAX_CONTROL = '0'
export const FEAT_STRIPE_TAX_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_STRIPE_TAX_ID] = {
  id: FEAT_STRIPE_TAX_ID,
  name: 'CXP-8306: Use Stripe Tax',
  variations: [
    {
      variationId: FEAT_STRIPE_TAX_CONTROL,
      variationName: 'Control: Use Avalara for tax'
    },
    {
      variationId: FEAT_STRIPE_TAX_VARIATION,
      variationName: 'Variation: Use Stripe for tax'
    }
  ]
}

export const FEAT_VARSITY_LEAGUE_EVENTS_ID = 'cxp_8698_varsity_league_events'
export const FEAT_VARSITY_LEAGUE_EVENTS_CONTROL = '0'
export const FEAT_VARSITY_LEAGUE_EVENTS_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_VARSITY_LEAGUE_EVENTS_ID] = {
  id: FEAT_VARSITY_LEAGUE_EVENTS_ID,
  name: 'CXP-8698: Varsity League Events',
  variations: [
    {
      variationId: FEAT_VARSITY_LEAGUE_EVENTS_CONTROL,
      variationName: 'Control: Hide League Events tab'
    },
    {
      variationId: FEAT_VARSITY_LEAGUE_EVENTS_VARIATION,
      variationName: 'Variation: Show League Events tab'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.VARSITY]
    }
  ]
}

export const EXP_ENTITY_HUBS_SCHEDULE_REDESIGN_2025_ID = 'cxp_7495_entity_hub_schedule_redesign'
export const EXP_ENTITY_HUBS_SCHEDULE_REDESIGN_2025_CONTROL = '0'
export const EXP_ENTITY_HUBS_SCHEDULE_REDESIGN_2025_VARIATION = '1'
ALL_EXPERIMENTS[EXP_ENTITY_HUBS_SCHEDULE_REDESIGN_2025_ID] = {
  id: EXP_ENTITY_HUBS_SCHEDULE_REDESIGN_2025_ID,
  name: 'CXP-7495: Entity Hubs Schedule Redesign',
  variations: [
    {
      variationId: EXP_ENTITY_HUBS_SCHEDULE_REDESIGN_2025_CONTROL,
      variationName: 'Control: Old Schedule Design'
    },
    {
      variationId: EXP_ENTITY_HUBS_SCHEDULE_REDESIGN_2025_VARIATION,
      variationName: 'Variation: Calendar Schedule Design'
    }
  ]
}

/**
 * CXP-8906: Signup Webflow Redirect - user is redirected to Webflow landing page when on the /signup page
 */
export const FEAT_WEBFLOW_SIGNUP_REDIRECT_ID = 'cxp_8906_webflow_signup_redirect'
export const FEAT_WEBFLOW_SIGNUP_REDIRECT_CONTROL = '0'
export const FEAT_WEBFLOW_SIGNUP_REDIRECT_VARIATION = '1'
ALL_EXPERIMENTS[FEAT_WEBFLOW_SIGNUP_REDIRECT_ID] = {
  id: FEAT_WEBFLOW_SIGNUP_REDIRECT_ID,
  name: 'CXP-8906: Signup Webflow Redirect',
  variations: [
    {
      variationId: FEAT_WEBFLOW_SIGNUP_REDIRECT_CONTROL,
      variationName: 'Control: No redirect'
    },
    {
      variationId: FEAT_WEBFLOW_SIGNUP_REDIRECT_VARIATION,
      variationName: 'Variation: Redirect to Webflow landing page'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLOGRAPPLING]
    }
  ]
}

/**
 * CXP-5332: Global schedule geo-blocking
 */
export const EXP_GLOBAL_SCHEDULE_GEO_BLOCKING_ID = 'cxp_5332_global_schedule_geo_blocking'
export const EXP_GLOBAL_SCHEDULE_GEO_BLOCKING_CONTROL = '0'
export const EXP_GLOBAL_SCHEDULE_GEO_BLOCKING_VARIATION = '1'
ALL_EXPERIMENTS[EXP_GLOBAL_SCHEDULE_GEO_BLOCKING_ID] = {
  id: EXP_GLOBAL_SCHEDULE_GEO_BLOCKING_ID,
  name: 'CXP-5332: Global schedule geo-blocking',
  variations: [
    {
      variationId: EXP_GLOBAL_SCHEDULE_GEO_BLOCKING_CONTROL,
      variationName: 'Control: No geo-blocking'
    },
    {
      variationId: EXP_GLOBAL_SCHEDULE_GEO_BLOCKING_VARIATION,
      variationName: 'Variation: Geo-block on global schedule'
    }
  ]
}

/**
 * CXP-9626: 149.88 price plan
 */
export const EXP_149_88_PRICE_PLAN_ID = 'cxp_9626_149_88_price_plan'
export const EXP_149_88_PRICE_PLAN_CONTROL = '0'
export const EXP_149_88_PRICE_PLAN_VARIATION = '1'
ALL_EXPERIMENTS[EXP_149_88_PRICE_PLAN_ID] = {
  id: EXP_149_88_PRICE_PLAN_ID,
  name: 'CXP-9626: 149.88 price plan',
  variations: [
    {
      variationId: EXP_149_88_PRICE_PLAN_CONTROL,
      variationName: 'Control: Show current pricing'
    },
    {
      variationId: EXP_149_88_PRICE_PLAN_VARIATION,
      variationName: 'Variation: Show yearly price - $149.88'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [
        SiteIds.FLOBASEBALL,
        SiteIds.FLOBIKES,
        SiteIds.FLOBOWLING,
        SiteIds.FLOCHEER,
        SiteIds.FLOCOMBAT,
        SiteIds.FLODANCE,
        SiteIds.FLOELITE,
        SiteIds.FLOFC,
        SiteIds.FLOFOOTBALL,
        SiteIds.FLOGRAPPLING,
        SiteIds.FLOGYMNASTICS,
        SiteIds.FLOHOCKEY,
        SiteIds.FLOHOOPS,
        SiteIds.FLOLIVE,
        SiteIds.FLOMARCHING,
        SiteIds.FLORODEO,
        SiteIds.FLORUGBY,
        SiteIds.FLOSOFTBALL,
        SiteIds.FLOSWIMMING,
        SiteIds.FLOTRACK,
        SiteIds.VARSITY,
        SiteIds.FLOVOICE,
        SiteIds.FLOVOLLEYBALL,
        SiteIds.FLOWRESTLING
      ]
    }
  ]
}

/**
 * CXP-9628: Order Summary Pay
 */

export const EXP_ORDER_SUMMARY_PAY_ID = 'cxp_9628_order_summary_pay'
export const EXP_ORDER_SUMMARY_PAY_CONTROL = '0'
export const EXP_ORDER_SUMMARY_PAY_VARIATION = '1'
ALL_EXPERIMENTS[EXP_ORDER_SUMMARY_PAY_ID] = {
  id: EXP_ORDER_SUMMARY_PAY_ID,
  name: 'CXP-9628: Order Summary Pay',
  variations: [
    {
      variationId: EXP_ORDER_SUMMARY_PAY_CONTROL,
      variationName: 'Control: Old Order Summary Pay'
    },
    {
      variationId: EXP_ORDER_SUMMARY_PAY_VARIATION,
      variationName: 'Variation: New Order Summary Pay'
    }
  ],
  criteria: [
    {
      type: 'vertical',
      inclusive: true,
      data: [SiteIds.FLORACING]
    }
  ]
}
